import { FolderDesignationEnum } from '@th-types/uploadImage.type';
import { privateApi } from '.';

export interface SignedDownloadUrl {
  url: string;
  validFor?: { seconds: number };
}

export const getWorkerCVDownloadUrl = async (
  s3FileId: number
): Promise<SignedDownloadUrl> => {
  const result = await privateApi.get<SignedDownloadUrl>(
    `files/${s3FileId}/download-url`,
    { params: { designation: FolderDesignationEnum.PERSON_RESUME } }
  );
  return result.data;
};
